import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { usePostHog } from './usePostHog'
import { useAuth } from '@/global/auth/AuthContext'

interface PageViewTrackerProps {
  appType: 'AMS' | 'FMA'
}

/**
 * Component that automatically tracks page views on route changes
 * Mount this once at the app root level
 */
export const PageViewTracker: React.FC<PageViewTrackerProps> = ({ appType }) => {
  const location = useLocation()
  const { track } = usePostHog()
  const { activeTenantId, user } = useAuth()

  useEffect(() => {
    track('$pageview', {
      $current_url: window.location.href,
      path: location.pathname,
      search: location.search,
      app_type: appType,
      tenant_id: activeTenantId,
      user_id: user?.id,
    })
  }, [location.pathname, location.search, track, appType, activeTenantId, user?.id])

  return null
}
